import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DasDisabledPipe} from './pipes/das-disabled.pipe';
import {DasEnabledPipe} from './pipes/das-enabled.pipe';
import {DasWorkflowToActionPipe} from './pipes/das-workflow-to-action.pipe';

@NgModule({
  imports: PermissionsModule.IMPORTS,
  declarations: PermissionsModule.DECLARATIONS,
  exports: PermissionsModule.DECLARATIONS
})
export class PermissionsModule {
  public static readonly IMPORTS: any[] = [CommonModule];

  public static readonly DECLARATIONS: any[] = [DasEnabledPipe, DasDisabledPipe, DasWorkflowToActionPipe];
}
